(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9793],{

/***/ 43989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/embedding",
      function () {
        return __webpack_require__(50596);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 18495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70231);


const GradientCheckIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "gradient",
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "0%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0%",
                            stopColor: "#a855f7"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "50%",
                            stopColor: "#6366f1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "100%",
                            stopColor: "#3b82f6"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_1__/* .FaRegCircleCheck */ .ReY, {
                style: {
                    fill: "url(#gradient)",
                    width: "100%",
                    height: "100%"
                }
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (GradientCheckIcon);


/***/ }),

/***/ 53684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57632);



const SampleEmbeddedForm = ()=>{
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let sessionInfoLocal = localStorage.getItem("sessionInfo");
        if (!sessionInfoLocal) {
            sessionInfoLocal = (0,uuid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
            localStorage.setItem("sessionInfo", sessionInfoLocal);
        }
        const script = document.createElement("script");
        script.id = "boloforms-embed-script";
        script.src = "https://appscript-scripts.s3.ap-south-1.amazonaws.com/boloforms-embed-index.min.js";
        script.async = true;
        script.onload = ()=>{
            if (document.querySelector("#embed-container").childElementCount > 0) return;
            // Create an instance of BoloFormsEmbed once the script is loaded
            const embed = new BoloFormsEmbed({
                containerId: "embed-container",
                token: "prod_emb_0338c78c-0169-4a05-b3ce-437988794b80",
                iframeOpts: {
                    width: "100%",
                    height: "600px"
                },
                sessionInfo: sessionInfoLocal
            });
        };
        document.body.appendChild(script);
        // used in start-taking-signature : to redirect to dashboard registration page
        window.addEventListener("message", (event)=>{
            if (event.data.redirectTo) {
                window.location.href = event.data.redirectTo;
            }
        });
        return ()=>{
            document.body.removeChild(script);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "embed-container"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SampleEmbeddedForm);


/***/ }),

/***/ 26239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Pricing_ApiAddonPricingCard2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/stripe.js
var stripe = __webpack_require__(42830);
// EXTERNAL MODULE: ./components/v2/Slider/CustomReactSlider.jsx
var CustomReactSlider = __webpack_require__(15662);
// EXTERNAL MODULE: ./utils/signature_owner.js
var signature_owner = __webpack_require__(10447);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 42 modules
var esm = __webpack_require__(62194);
// EXTERNAL MODULE: ./components/v2/Cards/GradientCheckIcon.jsx
var GradientCheckIcon = __webpack_require__(18495);
;// CONCATENATED MODULE: ./components/v2/Slider/CustomBoloSlider2.jsx



const CustomBoloSlider2 = (param)=>{
    let { defaultValue =1000 , min =500 , max =5000 , marks =[
        {
            value: 500,
            label: "500"
        },
        {
            value: 1000,
            label: "1000"
        },
        {
            value: 2000,
            label: "2000"
        },
        {
            value: 5000,
            label: "5000"
        }
    ] , onChange , currentActiveMark =0  } = param;
    const [value, setValue] = (0,react.useState)(defaultValue);
    const [isDragging, setIsDragging] = (0,react.useState)(false);
    const sliderRef = (0,react.useRef)(null);
    const thumbRef = (0,react.useRef)(null);
    // Find the closest mark value to snap to
    const findClosestMark = (currentValue)=>{
        return marks.reduce((closest, mark)=>{
            return Math.abs(mark.value - currentValue) < Math.abs(closest - currentValue) ? mark.value : closest;
        }, marks[0].value);
    };
    // Convert pixel position to value
    const getValueFromPosition = (position)=>{
        if (!sliderRef.current) return min;
        const rect = sliderRef.current.getBoundingClientRect();
        const percentage = (position - rect.left) / rect.width;
        const rawValue = min + (max - min) * Math.max(0, Math.min(1, percentage));
        return Math.round(rawValue);
    };
    // Convert value to percentage for positioning
    const getPercentage = (value)=>{
        if (value === 200) {
            return (value + 80 - min) / (max - min) * 100;
        }
        return (value - min) / (max - min) * 100;
    };
    const handleMouseDown = (e)=>{
        setIsDragging(true);
        const newValue = getValueFromPosition(e.clientX);
        setValue(newValue);
        if (onChange) onChange(newValue);
    };
    const handleMouseMove = (e)=>{
        if (!isDragging) return;
        const newValue = getValueFromPosition(e.clientX);
        setValue(newValue);
        if (onChange) onChange(newValue);
    };
    const handleMouseUp = ()=>{
        if (!isDragging) return;
        setIsDragging(false);
        const snappedValue = findClosestMark(value);
        setValue(snappedValue);
        if (onChange) onChange(snappedValue);
    };
    (0,react.useEffect)(()=>{
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        }
        return ()=>{
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        isDragging,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full py-8 select-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: sliderRef,
            className: "relative w-full h-2 bg-slate-200 cursor-pointer",
            onMouseDown: handleMouseDown,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute h-2 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 ",
                    style: {
                        width: "".concat(getPercentage(value), "%")
                    }
                }),
                marks.map((mark, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            left: "".concat(getPercentage(mark.value), "%")
                        },
                        className: "absolute",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute md:w-1 w-0.5 h-6 rounded-full   -translate-x-1/2 -translate-y-2 ".concat(mark.value <= value ? "bg-primary" : "bg-slate-400", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute text-xs -translate-x-1/2 mt-6 flex flex-col gap-1 items-center justify-center ".concat(mark.value <= value ? "text-primary font-bold" : "text-gray-600", " "),
                                children: mark.label
                            })
                        ]
                    }, mark.value)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: thumbRef,
                    className: "absolute w-6 h-6 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 rounded-full border-[3px] border-white shadow-md cursor-pointer transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-150 top-1/2 ",
                    style: {
                        left: "".concat(getPercentage(value), "%"),
                        transform: "translate(-50%, -50%) scale(".concat(isDragging ? 1.1 : 1, ")")
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Slider_CustomBoloSlider2 = (CustomBoloSlider2);

// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
;// CONCATENATED MODULE: ./components/v2/Pricing/ApiAddonPricingCard2.jsx













const ApiAddonPricingCard2 = (param)=>{
    let { currentPage , title , subTitle , bgColor ="bg-white" , cardBorder  } = param;
    var _featureDataObject_includes_currentPage;
    const [priceLoading, setPriceLoading] = (0,react.useState)(false);
    const featureDataObject = (0,react.useMemo)(()=>{
        return {
            title: "BoloSign API",
            desc: "Automate your signature workflow by integrating our API into your systems.",
            includes: {
                api: [
                    "BoloSign Webhooks",
                    "BoloSign Embeddings"
                ],
                embedding: [
                    "BoloSign Webhooks",
                    "BoloSign API"
                ]
            },
            features: [
                "BoloSign API Access",
                "BoloSign Webhooks",
                "BoloSign Embeddings",
                "Customizable Branding",
                "Session Control",
                "Create PDFs",
                "Send PDFs for signature",
                "Fetch PDF status in your website",
                "Zapier Integration",
                "Pabbly Integration",
                "Make (Integromat) Integration",
                "And more..."
            ]
        };
    }, []);
    const envelopeCountAndPrice = [
        {
            count: 100,
            price: 40
        },
        {
            count: 200,
            price: 72
        },
        {
            count: 500,
            price: 180
        },
        {
            count: 1000,
            price: 360
        },
        {
            count: 2000,
            price: 720
        },
        {
            count: 3000,
            price: "Contact Sales"
        }
    ];
    const [apiPrice, setApiPrice] = (0,react.useState)(envelopeCountAndPrice[1].price);
    const [documentSliderCount, setDocumentSliderCount] = (0,react.useState)(envelopeCountAndPrice[1].count);
    //   const ownerPlanDetails = getOwnerPlanDetails();
    //   const currentPlanTier = ownerPlanDetails?.currentPlan?.tier;
    //   const isCurrentPlanActive = ownerPlanDetails.currentPlan?.isActive;
    const handleSliderChange = (newValue)=>{
        setDocumentSliderCount(newValue);
        const selectedPrice = envelopeCountAndPrice.find((item)=>item.count === newValue);
        if (selectedPrice) {
            setApiPrice(selectedPrice.price);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " flex flex-col gap-y-2 w-full lg:p-6 p-4 md:p-10 border-2 border-slate-200 rounded-3xl relative mb-20 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl font-bold text-left",
                        children: title || featureDataObject.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-left text-gray-600 mt-4 ",
                        children: subTitle || featureDataObject.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex md:gap-8 gap-2 mt-4 lg:flex-row flex-col",
                        children: (_featureDataObject_includes_currentPage = featureDataObject.includes[currentPage]) === null || _featureDataObject_includes_currentPage === void 0 ? void 0 : _featureDataObject_includes_currentPage.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base leading-[24px] font-semibold  mb-1",
                                        children: item
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "space-y-2 min-h-[100px]",
                    children: apiPrice === "Contact Sales" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start items-center w-full min-h-[100px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-5xl font-bold text-black",
                            children: "Contact Sales"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-start items-end w-full h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-6xl font-bold",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-4xl mr-1",
                                                children: "$"
                                            }),
                                            apiPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-2xl ml-1",
                                        children: "/mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-left text-base text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-gray-700",
                                        children: "$0.5"
                                    }),
                                    " for each document beyond",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-gray-700 mx-1",
                                        children: documentSliderCount
                                    }),
                                    "limit."
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_CustomBoloSlider2, {
                    defaultValue: documentSliderCount,
                    min: 100,
                    max: 3000,
                    marks: envelopeCountAndPrice.map((item)=>({
                            value: item.count,
                            label: "".concat(item.count)
                        })),
                    onChange: handleSliderChange,
                    currentActiveMark: 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex justify-start items-center gap-3 md:flex-row flex-col my-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary1 */.au, {
                        buttonText: apiPrice === "Contact Sales" ? "Contact Sales" : "Subscribe Now",
                        className: "w-full md:w-auto",
                        onClick: async ()=>{
                            if (apiPrice === "Contact Sales") {
                                window === null || window === void 0 ? void 0 : window.Intercom("showNewMessage");
                            } else {
                                setPriceLoading(true);
                                await (0,stripe.createAPITierSubscriptions)({
                                    documentsCount: documentSliderCount
                                });
                                setPriceLoading(false);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMSecondaryBorder */.kL, {
                        className: "w-full md:w-auto",
                        onClick: ()=>{
                            window.open("https://signature.boloforms.com/register?from=API_PAGE".concat((0,signature_owner/* createUTMQueryParams */.T0)({
                                from: "API_PAGE"
                            })), "_self");
                        },
                        buttonText: "Try Sandbox Testing for $0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
                children: featureDataObject.features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base leading-[24px] font-medium  ",
                                children: feature
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var Pricing_ApiAddonPricingCard2 = (ApiAddonPricingCard2);


/***/ }),

/***/ 50596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93179);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51649);
/* harmony import */ var react_icons_pi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96225);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89583);
/* harmony import */ var react_icons_lu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1451);
/* harmony import */ var _utils_react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5847);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46687);
/* harmony import */ var _components_Embedded_SampleEmbeddedForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53684);
/* harmony import */ var _components_Subscribe__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18034);
/* harmony import */ var _components_Pricing_ApiAddonPricingCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8054);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56475);
/* harmony import */ var _components_Pricing_ApiAddonPricingCard2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26239);


















const Embedding = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign - AI for Smart Contract Management | Embedding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Embed BoloSign's document signing process into any web or mobile app."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "bolosign embedding, signature embedding, esignature embedding, bolosign esignature embedding, boloforms esignature embedding,esignature, electronic signature, document signing, document builder, forms, templates, boloforms, bolosign, embedding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://bolosign.com/signature/embedding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign - AI for Smart Contract Management | Embedding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Embed BoloSign's document signing process into any web or mobile app."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://bolosign.com/signature/embedding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign - AI for Smart Contract Management | Embedding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Embed BoloSign's document signing process into any web or mobile app."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/embedding"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "md:mt-20 mt-8 max-w-screen-xl mx-auto px-4 lg:px-8 mb-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "grid grid-cols-1 lg:grid-cols-2 items-center gap-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "max-w-3xl",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                className: "text-left text-4xl lg:text-5xl lg:leading-tight font-extrabold text-gray-900 mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent",
                                                        children: "Embedded"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    "Document Signing"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-left text-xl lg:leading-8 text-gray-700",
                                                children: [
                                                    "Use our ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                        children: "no-code"
                                                    }),
                                                    " solution to effortlessly integrate the document signing process into any web or mobile app."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-center lg:justify-start",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mt-8 flex items-center gap-3 flex-wrap",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_8__/* .CLMButtonPrimary */ .IS, {
                                                            buttonText: "Try now for free",
                                                            buttonUrl: "https://signature.boloforms.com/settings?type=DEV_SEC&subType=EMBED&from=EMBEDDING_PAGE"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_8__/* .CLMButtonSecondaryBorder */ .AL, {
                                                            buttonText: "Documentation",
                                                            buttonUrl: "https://developer.boloforms.com/",
                                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdLibraryBooks */ .dBs, {})
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: "#sample",
                                    className: "border bg-secondary rounded-2xl shadow-md overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex gap-4 items-center mx-4 my-3 py-1",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "bg-gray-500 rounded-full w-3 h-3"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "bg-gray-500 rounded-full w-3 h-3"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "bg-gray-500 rounded-full w-3 h-3"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "grow px-2 bg-white rounded-full flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_11__/* .IoIosSearch */ .FKI, {
                                                            className: "text-gray-500 text-xl"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "py-1",
                                                            children: "https://yourwebsite.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-4 bg-white",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "border p-4 rounded-lg relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mb-2.5 font-bold text-lg text-center",
                                                        children: "Your Document"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5 w-1/2"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5 w-1/2"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5 hidden lg:block"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5 hidden lg:block"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5 hidden lg:block"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5 hidden lg:block"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "h-3 bg-gray-200 rounded-full mb-2.5"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "grid grid-cols-2 gap-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "h-3 bg-gray-200 rounded-full"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "h-3 bg-gray-200 rounded-full"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex justify-between space-x-4 my-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "border border-red-400 rounded-lg opacity-50 flex items-center justify-center h-full w-full bg-red-100",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "flex justify-center items-center space-x-1 h-full",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdDateRange */ .f$3, {
                                                                        className: "text-4xl"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "border border-red-400 rounded-lg opacity-50 flex items-center justify-center h-full w-full bg-red-100",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "flex justify-center items-center space-x-1 h-full",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_pi__WEBPACK_IMPORTED_MODULE_12__/* .PiSignature */ .h1R, {
                                                                        className: "text-4xl"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex justify-center",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "bg-primary block text-center px-4 py-1 text-white border rounded-full",
                                                            children: "Submit Form"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "py-20 md:py-28",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "max-w-5xl mx-auto text-3xl sm:text-5xl font-bold text-center mb-10 sm:mb-16",
                                    children: "Pricing and Features"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-screen-xl mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Pricing_ApiAddonPricingCard2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        currentPage: "embedding",
                                        title: "Embedding",
                                        subTitle: "Streamline your signature workflow by embedding our solution directly into your systems."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: "w-full sm:mt-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid grid-cols-1 gap-8 sm:gap-16 lg:grid-cols-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-3xl lg:text-6xl text-gray-900 font-bold mb-4",
                                                children: "Integrate signing forms in a snap"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-lg md:text-2xl text-gray-700 ",
                                                    children: "Simply embed this code into any section of your website to seamlessly introduce the document signing process into your applications. It's an ideal solution tailored for CRM, KYC, and onboarding workflows, ensuring a streamlined experience for your users."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "my-auto overflow-hidden",
                                        id: "embed-section",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mx-auto my-auto sm:mx-0 sm:max-w-none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "bg-black text-white rounded-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-full flex items-center justify-between px-4 py-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: Array.from({
                                                                    length: 3
                                                                }, (_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "w-2 h-2 rounded-full bg-gray-200"
                                                                    }, index))
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex items-center gap-2 text-white cursor-pointer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                type: "radio",
                                                                                className: "peer hidden"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "peer-checked:hidden flex items-center space-x-2",
                                                                                onClick: ()=>navigator.clipboard.writeText('<script src="https://appscript-scripts.s3.ap-south-1.amazonaws.com/boloforms-embed-index.min.js"></script>\n\n<script>\n	// Create an instance of BoloFormsEmbed\n	let embed = new BoloFormsEmbed({\n		containerId: "embed-container",\n		token: "your-embed-key",\n		iframeOpts: { width: "100%", height: "600px" },\n		sessionInfo: { userId: 1, userName: "John Doe" },\n	});\n</script>'),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_13__/* .LuCopy */ .ef8, {}),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "hidden md:inline",
                                                                                        children: "Copy"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "hidden peer-checked:flex items-center space-x-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_13__/* .LuCopyCheck */ .Qo6, {}),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "hidden md:inline",
                                                                                        children: "Copied"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-full pt-0 p-2",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            language: "javascript",
                                                            style: _utils_react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_3__/* .a11yDark */ .V,
                                                            children: '<script src="https://appscript-scripts.s3.ap-south-1.amazonaws.com/boloforms-embed-index.min.js"></script>\n\n<script>\n	// Create an instance of BoloFormsEmbed\n	let embed = new BoloFormsEmbed({\n		containerId: "embed-container",\n		token: "your-embed-key",\n		iframeOpts: { width: "100%", height: "600px" },\n		sessionInfo: { userId: 1, userName: "John Doe" },\n	});\n</script>'
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            id: "sample",
                            className: "pt-16 sm:pt-28",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "max-w-5xl mx-auto text-3xl sm:text-5xl font-bold text-center mb-10 sm:mb-16",
                                    children: "Live Demo"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    href: "#sample",
                                    className: "border bg-secondary rounded-2xl shadow-md overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex gap-4 items-center mx-4 my-3 py-1",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "bg-gray-500 rounded-full w-3 h-3"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "bg-gray-500 rounded-full w-3 h-3"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "bg-gray-500 rounded-full w-3 h-3"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "grow px-2 bg-white rounded-full flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_11__/* .IoIosSearch */ .FKI, {
                                                            className: "text-gray-500 text-xl"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "py-1",
                                                            children: "https://yourwebsite.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-4 bg-white",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "border p-4 rounded-lg relative",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Embedded_SampleEmbeddedForm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: "w-full mt-16 sm:mt-32",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex flex-col gap-8 sm:gap-10 justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mx-auto lg:mx-0 lg:max-w-screen-md text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                className: "mx-auto text-3xl sm:text-5xl font-bold text-center mb-4 flex justify-center items-center gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_15__/* .FaReact */ .huN, {
                                                        className: "text-[#61dafb] text-4xl sm:text-5xl"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "For React Apps"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "my-4 text-lg sm:text-xl text-gray-700 tracking-tight",
                                                children: "Effortlessly incorporate BoloSign's React components into your application, providing you with the flexibility to tailor them precisely to your requirements, ensuring a cohesive user experience."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full max-w-screen-lg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "bg-black text-white rounded-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-full flex items-center justify-between px-4 py-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: Array.from({
                                                                    length: 3
                                                                }, (_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "w-2 h-2 rounded-full bg-gray-200"
                                                                    }, index))
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex items-center gap-2 text-white cursor-pointer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                type: "radio",
                                                                                className: "peer hidden"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "peer-checked:hidden flex items-center space-x-2",
                                                                                onClick: ()=>navigator.clipboard.writeText('import React, { useEffect } from "react";\n\nconst SampleEmbeddedForm = () => {\n  useEffect(() => {\n    const script = document.createElement("script");\n    script.src =\n      "https://appscript-scripts.s3.ap-south-1.amazonaws.com/boloforms-embed-index.min.js";\n    script.async = true;\n    script.onload = () => {\n      if (document.querySelector("#embed-container").childElementCount > 0)\n        return;\n\n      // Create an instance of BoloFormsEmbed once the script is loaded\n      const embed = new BoloFormsEmbed({\n        containerId: "embed-container",\n        token: "your-embed-key",\n        iframeOpts: { width: "100%", height: "600px" },\n        sessionInfo: { userId: 1, userName: "John Doe" },\n      });\n    };\n    document.body.appendChild(script);\n\n    return () => {\n      document.body.removeChild(script);\n    };\n  }, []);\n\n  return <div id="embed-container" />;\n};'),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_13__/* .LuCopy */ .ef8, {}),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "hidden md:inline",
                                                                                        children: "Copy"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "hidden peer-checked:flex items-center space-x-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_13__/* .LuCopyCheck */ .Qo6, {}),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "hidden md:inline",
                                                                                        children: "Copied"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-full pt-0 py-2 px-3",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            language: "javascript",
                                                            style: _utils_react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_3__/* .a11yDark */ .V,
                                                            children: 'import React, { useEffect } from "react";\n\nconst SampleEmbeddedForm = () => {\n  useEffect(() => {\n    const script = document.createElement("script");\n    script.src =\n      "https://appscript-scripts.s3.ap-south-1.amazonaws.com/boloforms-embed-index.min.js";\n    script.async = true;\n    script.onload = () => {\n      if (document.querySelector("#embed-container").childElementCount > 0)\n        return;\n\n      // Create an instance of BoloFormsEmbed once the script is loaded\n      const embed = new BoloFormsEmbed({\n        containerId: "embed-container",\n        token: "your-embed-key",\n        iframeOpts: { width: "100%", height: "600px" },\n        sessionInfo: { userId: 1, userName: "John Doe" },\n      });\n    };\n    document.body.appendChild(script);\n\n    return () => {\n      document.body.removeChild(script);\n    };\n  }, []);\n\n  return <div id="embed-container" />;\n};'
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Embedding);


/***/ }),

/***/ 5847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ a11yDark; }
/* harmony export */ });
const a11yDark = {
    'code[class*="language-"]': {
        color: "#f8f8f2",
        background: "none",
        fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        wordWrap: "normal",
        lineHeight: "1.5",
        MozTabSize: "4",
        OTabSize: "4",
        tabSize: "4",
        WebkitHyphens: "none",
        MozHyphens: "none",
        msHyphens: "none",
        hyphens: "none"
    },
    'pre[class*="language-"]': {
        color: "#f8f8f2",
        background: "#2b2b2b",
        fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        wordWrap: "normal",
        lineHeight: "1.5",
        MozTabSize: "4",
        OTabSize: "4",
        tabSize: "4",
        WebkitHyphens: "none",
        MozHyphens: "none",
        msHyphens: "none",
        hyphens: "none",
        padding: "1em",
        overflow: "auto",
        borderRadius: "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
        background: "#2b2b2b",
        padding: "0.1em",
        borderRadius: "0.3em",
        whiteSpace: "normal"
    },
    comment: {
        color: "#d4d0ab"
    },
    prolog: {
        color: "#d4d0ab"
    },
    doctype: {
        color: "#d4d0ab"
    },
    cdata: {
        color: "#d4d0ab"
    },
    punctuation: {
        color: "#fefefe"
    },
    property: {
        color: "#ffa07a"
    },
    tag: {
        color: "#ffa07a"
    },
    constant: {
        color: "#ffa07a"
    },
    symbol: {
        color: "#ffa07a"
    },
    deleted: {
        color: "#ffa07a"
    },
    boolean: {
        color: "#00e0e0"
    },
    number: {
        color: "#00e0e0"
    },
    selector: {
        color: "#abe338"
    },
    "attr-name": {
        color: "#abe338"
    },
    string: {
        color: "#abe338"
    },
    char: {
        color: "#abe338"
    },
    builtin: {
        color: "#abe338"
    },
    inserted: {
        color: "#abe338"
    },
    operator: {
        color: "#00e0e0"
    },
    entity: {
        color: "#00e0e0",
        cursor: "help"
    },
    url: {
        color: "#00e0e0"
    },
    ".language-css .token.string": {
        color: "#00e0e0"
    },
    ".style .token.string": {
        color: "#00e0e0"
    },
    variable: {
        color: "#00e0e0"
    },
    atrule: {
        color: "#ffd700"
    },
    "attr-value": {
        color: "#ffd700"
    },
    function: {
        color: "#ffd700"
    },
    keyword: {
        color: "#00e0e0"
    },
    regex: {
        color: "#ffd700"
    },
    important: {
        color: "#ffd700",
        fontWeight: "bold"
    },
    bold: {
        fontWeight: "bold"
    },
    italic: {
        fontStyle: "italic"
    }
};


/***/ }),

/***/ 57632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7627,9866,9570,3179,273,9774,2888,179], function() { return __webpack_exec__(43989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);